import { render, staticRenderFns } from "./Terms-Condition.vue?vue&type=template&id=30a3f337"
import script from "./Terms-Condition.vue?vue&type=script&lang=js"
export * from "./Terms-Condition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports